import  gql  from 'graphql-tag'

export const financialAssessments = gql`query FinancialAssessments($status: String, $analyst: ID, $office: ID,  $createdAt_Gt: DateTime, $createdAt_Lt: DateTime) {
  financialAssessments(status: $status, analyst: $analyst, office: $office, createdAt_Gt: $createdAt_Gt, createdAt_Lt: $createdAt_Lt) {
    edges{
      node{
        fm102{
          id
        }
        id
        financialAssessmentId
        jsonObject
        status
        createdAt
        debtor{
          fm100{
            id
          }
          id
          creditstudySet{
            edges{
              node{
                id
                productType{
                  id
                }
              }
            }
          }
          person{
            id
            fullName
            identificationNumber
          }
          spouse{
              person{
                  id
              }
              creditstudy{
                  id
              }
          }
        }
        codebtorSet{
          edges{
            node{
              id
              fm100{
                  id
              }
              creditstudySet{
                edges{
                  node{
                    id
                    productType{
                      id
                    }
                  }
                }
              }
              person{
                id
                fullName
                identificationNumber
              }
            }
          }
        }
        office{
          id
          regional{
            id
          }
        }
        analyst{
          user{
            id
            name
            surname
          }
        }
        changelogSet{
          edges{
            node{
              id
              stage
              description
              dateTime
            }
          }
        }
      }
    }
  }
}`;